import { render } from "./ReportProfit.vue?vue&type=template&id=dc6225dc&scoped=true"
import script from "./ReportProfit.vue?vue&type=script&lang=js"
export * from "./ReportProfit.vue?vue&type=script&lang=js"

import "./ReportProfit.vue?vue&type=style&index=0&id=dc6225dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc6225dc"]])

export default __exports__